<template>
  <div>
    <v-row
      class="px-4"
    >
      <p class="mr-2">Рейтинг заказа:</p>
      <star-rating
        :rating="review.rating"
        :read-only="true"
        :star-size="20"
        :show-rating="false"
        inactive-color="#e9e9e9"
        class="mb-2"
      />
    </v-row>
    <div class="text-sm leading-5 text-gray-500 pesponsive-text">
      <span>Комментарий клиента</span>
      <p>{{ review.comment }}</p>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'ViewRating',
  components: {
    StarRating,
  },
  props: {
    review: {
      type: Object,
      default: () => ({
        comment: '',
        rating: 0,
      }),
    },
  },
};
</script>

<style scoped>
.pesponsive-text {
  border-radius: 4px;
  border: solid 1px #ccc;
  padding: 15px;
  position: relative;
  overflow: inherit
}
.pesponsive-text p {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
  word-break: break-word;
}
.pesponsive-text span {
  position: absolute;
  background-color: #FAFAFA;
  top: -14px;
  left: 20px;
  font-size: 12px;
  color: #aaa;
  padding: 5px;
}
</style>
